import { render, staticRenderFns } from "./carouselInput.vue?vue&type=template&id=bd34af8a&scoped=true&lang=pug&"
import script from "./carouselInput.vue?vue&type=script&lang=js&"
export * from "./carouselInput.vue?vue&type=script&lang=js&"
import style0 from "./carouselInput.vue?vue&type=style&index=0&id=bd34af8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd34af8a",
  null
  
)

export default component.exports